module.exports = __webpack_public_path__ + "img/green-travel.8562aa33.jpg";